// This file is now empty as all platforms have been migrated to their own files
// or removed (PrestaShop, Bubble.io were removed per user request)

export const otherPlatforms = {};
